<template>
  <main class="view view--login view--new-app">
    <img class="logo" src="img/logo-negative.png" alt="" width="182" />

    <div class="alert alert-warning alert-migration">
      <p class="alert-migration__lead">{{ $t("Prixo has a new app. This app is no longer available.") }}</p>
      <p class="alert-migration__sub">{{ $t("Download the new app from the App Store or Play Store") }}</p>

      <div class="store-badges">
        <a
          class="store-badges__item"
          href="https://apps.apple.com/be/app/prixo-mobile/id6771777289?l=nl"
          target="_blank"
          rel="noopener"
        >
          <img
            class="store-badges__apple"
            src="img/badge-app-store.svg"
            alt="Download on the App Store"
          />
        </a>
        <a
          class="store-badges__item"
          href="https://play.google.com/store/apps/details?id=io.prixo.mobile&amp;hl=nl"
          target="_blank"
          rel="noopener"
        >
          <img
            class="store-badges__google"
            src="img/badge-google-play.png"
            alt="Get it on Google Play"
          />
        </a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "new-app",
};
</script>
